import { gql, useQuery } from '@apollo/client';

export const GET_HOLIDAY_LOCATION_BY_ID = gql`
  query getHolidayLocationById($holidayLocationId: String!) {
    getHolidayLocationById(holidayLocationId: $holidayLocationId) {
      _id
      name
      createdBy
    }
  }
`;

export const useGetHolidayLocationById = (holidayLocationId?: string) => {
  const { data, loading, refetch } = useQuery(GET_HOLIDAY_LOCATION_BY_ID, {
    variables: { holidayLocationId },
    skip: !holidayLocationId,
  });

  const holidayLocation = data?.getHolidayLocationById || {};

  return { holidayLocation, loading, refetch };
};
